import { useEffect } from "react";
import { useAppBridge } from "@shopify/app-bridge-react";
import { Fullscreen } from "@shopify/app-bridge/actions";

export default function useFullscreen() {
  const app = useAppBridge();
  const fullscreen = Fullscreen.create(app);

  return useEffect(() => {
    fullscreen.dispatch(Fullscreen.Action.ENTER);
    return () => {
      fullscreen.dispatch(Fullscreen.Action.EXIT);
    };
  }, []);
}
